import { PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteWrapperProps extends PropsWithChildren {
    condition: boolean;
    redirectPath: string;
}

export const ProtectedRouteWrapper = ({
    redirectPath,
    condition,
    children,
}: ProtectedRouteWrapperProps) => {
    if (!condition) {
        return <Navigate to={redirectPath} replace />;
    }

    return children ? <>{children}</> : <Outlet />;
};
